import { Theme } from '@emotion/react';
import styled from '@emotion/styled';

import type { SectionTitleType } from './types';

const mapColor = (theme: Theme, color: SectionTitleType = 'default') =>
  ({
    default: theme.colors.brand.orange120,
    'brand-orange': theme.colors.brand.orange140,
    'brand-green': theme.colors.brand.green160,
  })[color];

const Wrapper = styled.span<{
  sectionTitleType: SectionTitleType;
}>`
  display: inline-block;
  position: relative;
  padding: 0.25rem 0 0.75rem;
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 1.5;
  fill: currentcolor;
  color: ${({ theme, sectionTitleType }) => mapColor(theme, sectionTitleType)};
  gap: 0.625rem;
  margin-bottom: 1.5rem;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: -3px;
    right: -3px;
    height: 3px;
    border-radius: 1.5px;
    background: ${({ theme, sectionTitleType }) =>
      mapColor(theme, sectionTitleType)};
  }
`;

export { Wrapper };
